import { auth } from '@/plugins/Firebase';
import "@/types"

var _sequence:Sequence = {
        name: "",
        email: "",
        uiId: "",
        videoDurationSecs: 30,
        startDate: new Date(),
        endDate: new Date(),
        dailyStart: "00:00",
        dailyEnd: "23:59",
        width: 1280, 
        height: 720,
        crop: false,
        bitrate: 30,
        framerate: 25,
        blend: "average",
        partners: String[0],
        clients: String[0],
        users: String[0],
        progress: 0,
        status: "scheduled",
        thumbnail:"",        
        views: String[0],
        vimeoUri:""
}

export default {
  namespaced: true,
  
  state: _sequence,

  mutations: {
    setName: (state:Sequence, name:string) => {
     state.name = name
   },
   setEmail: (state:Sequence, email:string) => {
    state.email = email
  },
   setStartDate: (state:Sequence, startDate:Date) => {
    state.startDate = startDate
   },
   setEndDate: (state:Sequence, endDate:Date) => {
    state.endDate = endDate
   },
   setDailyStart: (state:Sequence, dailyStart:string) => {
    state.dailyStart = dailyStart
   },
   setDailyEnd: (state:Sequence, dailyEnd:string) => {
    state.dailyEnd = dailyEnd
   },
   setBitRate: (state:Sequence, bitRate:number) => {
    state.bitrate = bitRate
   },
   setFrameRate: (state:Sequence, frameRate:number) => {
    state.framerate = frameRate
   },
   setWidth: (state:Sequence, width:number) => {
    state.width = width
   },
   setHeight: (state:Sequence, height:number) => {
    state.height = height
   },
   setUiId: (state:Sequence, uiId:string) => {
    state.uiId = uiId
   },
   setVideoDurationSecs: (state:Sequence, videoDurationSecs:number) => {
    state.videoDurationSecs = videoDurationSecs
   },
  },

  actions: {
    
  },

  getters: {

  }
}